import React from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './CountryCodeSelector.css';

interface CountryCodeSelectorProps {
	value: string | undefined;
	onChange: (value: string | undefined) => void;
	name: string;
}

const CountryCodeSelector: React.FC<CountryCodeSelectorProps> = ({ value, onChange, name }) => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-5 col-md-4 col-lg-4 country-code-left">
				<div className="textbox-country-indicator">
					<div className="custom-country-title">{t('countryCodeSelector.title')}</div>
					<div className="country-info">
						<PhoneInput
							autoComplete="off"
							id={`phoneInputId-${name}`}
							name={name}
							international
							defaultCountry="US"
							placeholder="+1"
							value={value as any}
							onChange={onChange}
							countries={[
								'AG',
								'AR',
								'AW',
								'BS',
								'BB',
								'BZ',
								'BO',
								'BQ',
								'BR',
								'CA',
								'CL',
								'CO',
								'CR',
								'CU',
								'CW',
								'DM',
								'EC',
								'SV',
								'US',
								'GD',
								'GL',
								'GT',
								'GF',
								'GQ',
								'GY',
								'HT',
								'HN',
								'KY',
								'TC',
								'VG',
								'JM',
								'MQ',
								'MX',
								'NI',
								'PA',
								'PY',
								'PE',
								'PR',
								'DO',
								'KN',
								'VC',
								'LC',
								'SR',
								'TT',
								'UY',
								'VE',
								'AL',
								'DZ',
								'AM',
								'AT',
								'AZ',
								'BY',
								'BE',
								'BA',
								'BG',
								'CN',
								'HR',
								'CY',
								'CZ',
								'DK',
								'EG',
								'EE',
								'FI',
								'FR',
								'GE',
								'DE',
								'GR',
								'HK',
								'HU',
								'IS',
								'IN',
								'IE',
								'IL',
								'IT',
								'JP',
								'JO',
								'XK',
								'LV',
								'LB',
								'LY',
								'LI',
								'LT',
								'LU',
								'MT',
								'MD',
								'ME',
								'MA',
								'NL',
								'NZ',
								'NG',
								'MK',
								'NO',
								'PS',
								'PL',
								'PT',
								'RO',
								'RU',
								'RS',
								'SG',
								'SK',
								'SI',
								'ZA',
								'KR',
								'ES',
								'SE',
								'CH',
								'SY',
								'TW',
								'TN',
								'TR',
								'UA',
								'GB',
							]}
						/>
					</div>
				</div>
			</div>
			<div className="col-7 col-md-8 col-lg-8 country-code-right">
				<div className="input-container label-container">
					<input
						type="number"
						name={`mobileNumber-${name}`}
						className="textbox-tel"
						// El onChange de este input debe ser manejado por el padre si se requiere
					/>
					<label className="label-input">{t('countryCodeSelector.placeholder')}</label>
				</div>
			</div>
		</div>
	);
};

export default CountryCodeSelector;
